// DS: DS9.7
import React from 'react';
import { BIEventData } from '@wix/da-bi/pkg/types';
import c from 'classnames';
import Button from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './EmptyState.scss';

export interface Props {
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  illustration?: React.ReactNode;
  withIllustrationBelow?: boolean;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  view?: 'large' | 'small' | 'wide';
  withButton?: boolean;
  buttonLabel?: string;
  customButton?: React.ReactNode;
  onButtonClick?: () => void;
  biData?: BIEventData;
}

const EmptyState: React.FC<Props> = ({
  className,
  titleClassName,
  subtitleClassName,
  view = 'large',
  withIllustrationBelow,
  title,
  subtitle,
  illustration,
  withButton,
  buttonLabel,
  customButton,
  onButtonClick,
  biData,
}) => {
  return (
    <div className={c(s['root'], s[view], className)}>
      {illustration && (
        <div
          className={c(
            s['illustration'],
            withIllustrationBelow && s['illustration-below']
          )}
        >
          {illustration}
        </div>
      )}
      <div className={c(s['title'], titleClassName)}>{title}</div>
      <div className={c(s['subtitle'], subtitleClassName)}>{subtitle}</div>
      {withButton && (
        <Button
          variant="main"
          size="medium"
          onClick={onButtonClick}
          className={s['button']}
          biData={biData}
        >
          {buttonLabel}
        </Button>
      )}
      <div className={s['button']}>{customButton}</div>
    </div>
  );
};
EmptyState.displayName = 'EmptyState';

export default EmptyState;
